import React from 'react';

const ValueEffects = () => {
  const effects = [
    {
      title: "Decision-making",
      description: "When you’re faced with a difficult decision—such as choosing a career path or managing a relationship—your values often operate in the background, helping you lean toward options that “feel right” or align with your sense of integrity."
    },
    {
      title: "Motivation and well-being",
      description: "Values create a sense of purpose and direction. Working toward goals that reflect your values tends to be more fulfilling than chasing external rewards alone."
    },
    {
      title: "Identity and consistency",
      description: "Your values help form your identity. Living in line with your values produces a sense of internal harmony, while going against them can create emotional conflict or distress."
    },
    {
      title: "Relationships and social interactions",
      description: "Shared values with friends, family, or coworkers can foster connection and trust. Conversely, divergent values can lead to conflict or misunderstandings."
    },
    {
        title: "Behavior regulation",
        description: "Personal values guide your conduct across different situations."
      },
  ];

  return (
    <section>
      <h2 className="section-title">How Values Affect Your Life</h2>
      <div className="section-card">
        <p>
          Values serve as an internal compass that guides our choices and behaviors. 
          They influence virtually every aspect of our lives, from major life decisions to 
          everyday interactions.
        </p>
        <div className="effects-grid">
          {effects.map((effect, index) => (
            <div key={index} className="effect-item">
              <h3>{effect.title}</h3>
              <p>{effect.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueEffects;